/**
 * Central SEO metadata for all static pages (marketing, products, hub listings, 404).
 * Edit titles, descriptions, and canonical paths here — pages read via PageSeoHelmet / DetailPageHelmet.
 */
export const STATIC_PAGE_SEO_META = {
  home: {
    pageTitle: 'Charlee.ai | AI Intelligence Platform for Insurance Claims',
    metaDescription:
      'Charlee.ai is the AI intelligence platform for insurance claims — reducing severity, litigation, and fraud while optimizing reserves and simplifying claims workflows.',
    canonicalPath: '/',
  },
  about: {
    pageTitle: 'About Us | Charlee.ai',
    metaDescription:
      'Learn how Charlee.ai is transforming insurance through AI innovation — meet our team and discover our mission in claims and underwriting technology.',
    canonicalPath: '/about',
  },
  partners: {
    pageTitle: 'Partners | Charlee.ai',
    metaDescription:
      'Partner with Charlee.ai to deliver AI-powered claims and underwriting solutions. Explore partnership opportunities with leading insurers and technology providers.',
    canonicalPath: '/partners',
  },
  contact: {
    pageTitle: 'Contact Us | Charlee.ai',
    metaDescription:
      'Get in touch with Charlee.ai — book a demo, ask questions, or connect with our team about AI solutions for insurance claims and underwriting.',
    canonicalPath: '/contact',
  },
  solutions: {
    pageTitle: 'Solutions & Research | Charlee.ai',
    metaDescription:
      'Browse Charlee.ai solutions research — use cases, case studies, white papers, and blogs on AI for claims, underwriting, fraud, and insurance operations.',
    canonicalPath: '/solutions',
  },
  videos: {
    pageTitle: 'Product Videos | Charlee.ai',
    metaDescription:
      'Watch Charlee.ai product overview and demo videos — learn how our AI platform supports claims, DocuCharlee, user roles, and proof-of-concept workflows.',
    canonicalPath: '/videos',
  },
  notFound: {
    pageTitle: 'Page Not Found | Charlee.ai',
    metaDescription:
      'This Charlee.ai page could not be found. Return to the homepage or explore our insights on AI for insurance claims and underwriting.',
  },
  products: {
    askcharlee: {
      pageTitle: 'AskCharlee | AI Claims Insights | Charlee.ai',
      metaDescription:
        'AskCharlee is an AI-powered conversational assistant that delivers instant answers and insights from complex insurance data and claim notes to streamline claims management.',
      canonicalPath: '/product/askcharlee',
    },
    seecharlee: {
      pageTitle: '4SeeCharlee | Predictive Claims Analytics | Charlee.ai',
      metaDescription:
        '4SeeCharlee delivers severity management, litigation prediction, and attorney involvement tracking so claims teams can act earlier and improve outcomes.',
      canonicalPath: '/product/seecharlee',
    },
    docucharlee: {
      pageTitle: 'DocuCharlee | AI Claim Summaries | Charlee.ai',
      metaDescription:
        'DocuCharlee uses AI and natural language processing to create clear, concise claim summaries so insurers save time and make better decisions faster.',
      canonicalPath: '/product/docucharlee',
    },
    findcharlee: {
      pageTitle: 'FindCharlee | AI Fraud Detection | Charlee.ai',
      metaDescription:
        'FindCharlee uses AI and machine learning to detect suspicious insurance claims by analyzing behavioral patterns, claim history, and risk signals.',
      canonicalPath: '/product/findcharlee',
    },
    ritecharlee: {
      pageTitle: 'RiteCharlee | Risk Intelligence for Insurance | Charlee.ai',
      metaDescription:
        'RiteCharlee delivers risk intelligence from 60M+ claims to help underwriting, actuarial, and product teams select risks, price confidently, and design better offerings.',
      canonicalPath: '/product/ritecharlee',
    },
  },
  hub: {
    all: {
      pageTitle: 'Insights Hub | Charlee.ai',
      metaDescription:
        'Explore blogs, events, podcasts, and news from Charlee.ai — AI for insurance claims and underwriting.',
      canonicalPath: '/articles/all',
    },
    events: {
      pageTitle: 'Events | Charlee.ai',
      metaDescription:
        'Upcoming and past Charlee.ai events, webinars, and industry meetups for insurance professionals.',
      canonicalPath: '/articles/events',
    },
    news: {
      pageTitle: 'News | Charlee.ai',
      metaDescription:
        'Latest insurance industry news and Charlee.ai updates on AI-powered claims and underwriting.',
      canonicalPath: '/articles/news',
    },
    podcasts: {
      pageTitle: 'Podcasts | Charlee.ai',
      metaDescription:
        'Listen to Charlee.ai podcasts on insurance innovation, AI, and digital transformation.',
      canonicalPath: '/articles/podcasts',
    },
    blogs: {
      pageTitle: 'Blogs | Charlee.ai',
      metaDescription:
        'Read Charlee.ai blog posts on insurance technology, AI claims, and underwriting automation.',
      canonicalPath: '/articles/blogs',
    },
    usecases: {
      pageTitle: 'Use Cases | Charlee.ai',
      metaDescription:
        'See how insurers use Charlee.ai for claims, underwriting, and operational excellence.',
      canonicalPath: '/articles/usecases',
    },
  },
};

/** Hub listing sections — alias for STATIC_PAGE_SEO_META.hub */
export const HUB_SECTION_META = STATIC_PAGE_SEO_META.hub;
